import {match, Pattern} from 'ts-pattern';

import {openNewTab} from './openNewTab';

export const openAdLink = (originalUrl: string, market: string, language: string) => {
  const url = match<{market: string; language: string}, string>({market, language})
    .with({market: 'AUT', language: Pattern.any}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.at/angebote/')
    )
    .with({market: 'BEL', language: 'nl'}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.be/nl/aanbod/')
    )
    .with({market: 'BEL', language: Pattern.not('nl')}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.be/fr/offres/')
    )
    .with({market: 'ESP', language: Pattern.any}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.es/anuncios/')
    )
    .with({market: 'FRA', language: Pattern.any}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.fr/offres/')
    )
    .with({market: 'ITA', language: Pattern.any}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.it/annunci/')
    )
    .with({market: 'LUX', language: Pattern.any}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.lu/offres/')
    )
    .with({market: 'NLD', language: Pattern.any}, () =>
      originalUrl.replace('autoscout24.de/angebote/', 'autoscout24.nl/aanbod/')
    )
    .otherwise(() => originalUrl);

  openNewTab(url);
};
